const showError = (errorMessage) => {
    const messagesContainer = document.querySelector('.messages')
    let customMessagesEl = document.querySelector('.custom-messages')

    // Only create the .custom-messages element if it doesn't exist
    if (!customMessagesEl) {
        customMessagesEl = document.createElement('div')
        customMessagesEl.classList.add('custom-messages')
        messagesContainer.insertAdjacentElement('afterend', customMessagesEl)
    }

    // Only add the errorMessage if it hasn't been added before
    if (!customMessagesEl.querySelector('.msg-error')) {
        const errorElementHtml = `
            <div class="custom-message msg-error" role="alert">
              <div class="container">
                <span data-testid="notifierMessage">
                    ${errorMessage}
                </span>
              </div>
            </div>
        `
        customMessagesEl.insertAdjacentHTML('afterbegin', errorElementHtml)

        const errorElement = document.querySelector('.msg-error')
        errorElement.addEventListener('click', () => {
            errorElement.remove()
            clearTimeout(timeout)
        })

        const timeout = setTimeout(() => {
            const errorElement = document.querySelector('.msg-error')
            if (errorElement) {
                errorElement.remove()
            }
        }, 7000)
    }
}
function generateQuery() {
    const codes = document.querySelectorAll('.products .product [data-micro="sku"]')

    if (codes) {
        let codesArr = []

        for (const [i, code] of codes.entries()) {
            let pCode = code.textContent

            if (i === codes.length - 1) {
                const codeString = `[]=${pCode}`
                codesArr.push(codeString)
            } else {
                const codeString = `[]=${pCode}&codes`
                codesArr.push(codeString)
            }
        }

        return codesArr.join('')
    }
}

const expeditionAvailability = () => {
    const codes = document.querySelectorAll('.products .product [data-micro="sku"]')

    if (codes) {
        const finalQuerry = generateQuery()

        const url = `https://aplikace.mimedigital.cz/supporting-endpoints.happy-zoo/?codes${finalQuerry}`
        // const url = generateProductCodeUrl()

        const xhr = new XMLHttpRequest()
        xhr.open('GET', url)

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
                const productStocks = JSON.parse(xhr.responseText)

                const products = document.querySelectorAll('.products .product')

                if (products) {
                    for (const product of products) {
                        const pCode = product.querySelector('[data-micro="sku"]')?.textContent
                        const btn = product.querySelector('.btn')
                        let finalStockQty = 0

                        for (const item of Object.entries(productStocks)) {
                            const itemCode = item[1].code
                            const stockId = item[1].stock.id
                            const stockQty = item[1].amount

                            if (itemCode === pCode && stockId === 1 && stockQty > 0) {
                                product.querySelector(
                                    '.availability span:not(.availability-amount)'
                                ).textContent = 'skladem ihned k expedici'
                            }

                            if (itemCode === pCode) {
                                finalStockQty += stockQty
                            }
                        }

                        btn.addEventListener('click', () => {
                            for (const item of Object.entries(productStocks)) {
                                const itemCode = item[1].code
                                const param = item[1].paramQualityStandard
                                const cartQty = Number(product.querySelector('.amount').value)

                                if (itemCode === pCode && param === 'X') {
                                    if (cartQty > finalStockQty) {
                                        showError(
                                            'Vložili jste do košíku více kusů, než máme momentálně skladem. Doba expedice Vaší objednávky se tak může prodloužit o počet dní uvedený v detailu produktu.'
                                        )
                                    }
                                }
                            }
                        })
                    }
                }
            }
        }
        xhr.send()
    }
}

function catOrderRecap() {}
const labelsFn = () => {
    const labels = document.querySelectorAll('#category-header fieldset label:not([for="custom"])')
    const btnSales = document.querySelector("#category-header fieldset [for='order1']")
    const mobileSort = document.querySelector('.mobile-sort')
    const header = document.querySelector('#category-header form fieldset')

    const template = `<input type="radio" value="priority-custom" id="custom"><label for="custom">Doporučujeme</label>`

    if (!document.querySelector('input#custom')) {
        header.insertAdjacentHTML('beforeend', template)
    }

    const btnRecommend = document.querySelector("#category-header fieldset [for='custom']")
    const btnRecommendInput = document.querySelector('#category-header fieldset #custom')

    const changeState = () => {
        btnSales.click()
        sessionStorage.setItem('sort', 'yes')
    }

    if (labels) {
        labels.forEach((label) => {
            label.addEventListener('click', () => {
                let data = sessionStorage.getItem('sort')

                if (data) sessionStorage.removeItem('sort')
            })
        })
    }

    if (mobileSort) {
        mobileSort.addEventListener('change', (e) => {
            if (mobileSort.value !== 'priority') {
                let data = sessionStorage.getItem('sort')

                if (data) sessionStorage.removeItem('sort')
            }

            if (mobileSort.value === 'priority') {
                e.preventDefault()
                changeState()
            }
        })
    }

    if (btnRecommend) {
        btnRecommend.addEventListener('click', (e) => {
            e.preventDefault()
            console.log('click')
            changeState()
        })

        // if (btnRecommendInput.checked) {
        //     changeState()
        // }
    }
}
const sortByFlag = () => {
    const tip = document.querySelector("label[for='dd[]3']")

    let data = sessionStorage.getItem('sort')
    let typeOfSort = sessionStorage.getItem('type-sort')

    const clickTip = (reverse) => {
        if (tip && !tip.classList.contains('active')) {
            tip.click()
        }

        if (reverse && tip && tip.classList.contains('active')) {
            tip.click()
        }
    }

    if (data === 'yes') {
        const btnRecommendInput = document.querySelector('#category-header fieldset #custom')

        let products = document.querySelectorAll('.products:not(#productsTop) .product')
        products = [...products].reverse()

        if (products) {
            products.forEach((product) => {
                const flag = product.querySelector('.flag.flag-jakostni-norma ')
                const url = product.querySelector('a')?.href

                const btn = product.querySelector('.btn')
                const link = product.querySelector('.name[data-micro="url"]')?.href

                if (flag) {
                    product.classList.add('disabled-btn')

                    if (btn.classList.contains('is-disabled')) return

                    btn.addEventListener('click', (evt) => {
                        evt.preventDefault()
                    })

                    btn.insertAdjacentHTML(
                        'afterend',
                        `<span class = "pickup-only-notice">K zakoupení pouze na kamenné prodejně</span>
                                 <a href = "${link}" class = "btn btn-cart add-to-cart-button to-detail">Detail</a>
                        `
                    )

                    btn.classList.add('is-disabled')
                }
                // })
            })
        }

        const mobile = document.querySelector('.mobile')

        if (mobile) {
            const mobileSort = document.querySelector('.mobile-sort')

            if (mobileSort) mobileSort.value = 'priority'
        }

        document.querySelector('input#order1').checked = false
        btnRecommendInput.checked = true
    }

    const activeLabel = document.querySelector(
        ".category-header input[type='radio']:checked+label"
    )?.textContent

    const targetLabelName = 'Doporučujeme'
    const otherLabes = ['Nejlevnější', 'Nejdražší', 'Nejprodávanější', 'Abecedně']

    if (activeLabel === targetLabelName && typeOfSort === targetLabelName) {
        clickTip()
    }

    if (activeLabel === targetLabelName) {
        clickTip()
    }

    if (otherLabes.some((v) => activeLabel.includes(v)) && typeOfSort === targetLabelName) {
        clickTip(true)
    }

    sessionStorage.setItem('type-sort', activeLabel)
}
const sortMoreBtn = () => {
    let data = sessionStorage.getItem('sort')
    let elements = document.querySelectorAll('.products-block .product')
    elements = [...elements]
    elements = elements.reverse()

    if (data) {
        let lastProductCurrentCounter = 0
        const lastProduct = document.querySelector('.products .product:last-child')

        lastProduct.classList.add('last-product')

        let lastProductCurrent = document.querySelectorAll('.products-block .last-product')
        lastProductCurrent = [...lastProductCurrent].reverse()[1]

        if (lastProductCurrent === 'undefined') lastProductCurrent = lastProductCurrent[0]

        for (let product of elements) {
            if (product.classList.contains('last-product')) lastProductCurrentCounter++
            if (lastProductCurrentCounter === 2) break

            const flag = product.querySelector('.flag.flag-tip')

            if (flag) {
                product.classList.add('has-tip')

                lastProductCurrent.insertAdjacentElement('beforebegin', product)
            }
        }
    }
}
const disableBtn = () => {
    const products = document.querySelectorAll('.products:not(#productsTop) .product')

    if (products) {
        for (let product of products) {
            const flag = product.querySelector('.flag.flag-jakostni-norma')
            const btn = product.querySelector('.btn')
            const link = product.querySelector('.name[data-micro="url"]')?.href

            if (flag) {
                product.classList.add('disabled-btn')

                if (!btn.classList.contains('is-disabled')) {
                    btn.addEventListener('click', (evt) => {
                        evt.preventDefault()
                    })

                    btn.insertAdjacentHTML(
                        'afterend',
                        `<span class = "pickup-only-notice">K zakoupení pouze na kamenné prodejně</span>
                            <a href = "${link}" class = "btn btn-cart add-to-cart-button to-detail">Detail</a>
                        `
                    )

                    btn.classList.add('is-disabled')
                }
            }
            // })
        }
    }
}
const mobileSort = () => {
    const mobileSort = document.querySelector('.mobile-sort')

    if (mobileSort) {
        mobileSort.insertAdjacentHTML('beforeend', `<option value="priority">Doporučujeme</option>`)
    }
}

const defaultState = () => {
    const isSort = sessionStorage.getItem('sort')
    const isTypeSort = sessionStorage.getItem('type-sort')

    if (isSort) {
        sessionStorage.removeItem('sort')
    }

    if (isTypeSort) {
        sessionStorage.removeItem('type-sort')
    }
}
$(document).ready(function () {
    const category = document.querySelector('.type-category')
    const search = document.querySelector('.type-search')

    if (search || checkUrlForVyhledavani()) {
        console.log('rn search')
        disableBtn()
        expeditionAvailability()

        document.addEventListener('ShoptetDOMPageContentLoaded', function () {
            disableBtn()
            expeditionAvailability()
        })
        document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
            expeditionAvailability()
        })
        document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
            expeditionAvailability()
        })
    }

    if (category) {
        defaultState()
        mobileSort()
        expeditionAvailability()
        labelsFn()
        sortByFlag()
        disableBtn()

        document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
            expeditionAvailability()
        })

        document.addEventListener('ShoptetDOMPageContentLoaded', function () {
            mobileSort()
            labelsFn()
            sortByFlag()
            expeditionAvailability()
            disableBtn()
        })

        document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
            disableBtn()
            expeditionAvailability()
        })

        document.addEventListener('ShoptetPagePaginationUsed', function () {
            document.addEventListener('ShoptetDOMPageContentLoaded', function () {
                sortByFlag()
                disableBtn()
            })
        })
    }
})
